// extracted by mini-css-extract-plugin
module.exports = {"body":"a10a3f92e9--body--cdP1j"};